import * as config from "util/config";

const loansIsNotAvailable = (overdueStatus) => {
    const loansNotAvailableConfig = config.get("loans.overdueStatus.notAvailable", "");
    const loansNotAvailable = loansNotAvailableConfig.split("|");
    return loansNotAvailable.includes(overdueStatus);
};

export default loansIsNotAvailable;
